<template>
  <div class="inline-flex items-center">
    <a
      v-if="hasLoaded && termExists"
      :href="termDownloadLink"
      download
      class="inline-flex items-center"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot>
        Download
      </slot>
    </a>
    <mia-spinner
      v-if="!hasLoaded"
      class="w-4 h-4 text-orange-mia"
    />
  </div>
</template>

<script>
import Spinner from '@/components/ui/loader/Spinner.vue'

export default {
  name: 'MiaTermDownloadLink',

  components: {
    'mia-spinner': Spinner
  },

  props: {
    term: {
      type: String,
      required: true
    },

    type: {
      type: String,
      default: 'terms'
    }
  },

  data: () => ({
    hasLoaded: false,
    termExists: false
  }),

  computed: {
    termDownloadLink() {
      return `${process.env.VUE_APP_PROVIDER}/action/get${this.type}/${this.term}`
    },

    termExistenceLink() {
      return `${process.env.VUE_APP_PROVIDER}/action/has${this.type}/${this.term}`
    }
  },

  created() {
    this.checkExistence()
  },

  methods: {
    async checkExistence() {
      try {
        await window.axios.get(this.termExistenceLink)
        this.termExists = true
      } catch (e) {
        this.termExists = false
      }

      this.hasLoaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  height: 39px;
}
</style>
